export const orderImport = {
  label: {
    pageHeader1: 'Importer un panier sauvegardé',
    pageHeader2: 'Le fichier importé sera utilisé pour créer un panier sauvegardé.',
    fileFormatHeader: 'Le fichier texte doit lister les SKU des produits et les quantités dans le format suivant :',
    format1: 'SKU, Quantité',
    format2: 'Taille maximale du fichier : 88,12 Ko',
    fileUploadHeader: 'Sélectionnez un fichier à téléverser. Le fichier doit être un fichier Excel avec l\'extension XLS ou XLSX.',
    chooseFile: 'Choisir un fichier',
    import: 'Importer',
    importErrorsInfo: 'Des erreurs ont été rencontrées lors de l\'importation de la commande. Veuillez cliquer sur l\'icône pour plus de détails.',
    importErrorsTitle: 'Erreurs d\'importation de la commande',
    importResultTitle: 'Résultat de l\'importation de la commande',
    importSummary: 'Nous avons traité votre importation avec succès et trouvé <strong>{{importedProducts}}</strong> articles valides sur <strong>{{totalProducts}}</strong>, prêts à être ajoutés à votre commande provisoire.<br><br>Veuillez consulter les entrées invalides ci-dessous, corrigez-les ou procédez au panier.',
    importSummarySuccess: 'Nous avons traité votre importation avec succès et trouvé <strong>{{importedProducts}}</strong> articles valides sur <strong>{{totalProducts}}</strong>, prêts à être ajoutés à votre commande provisoire.<br><br>Veuillez procéder au panier.',
    importSummaryNoCount: 'Votre fichier a été traité. 0 enregistrement trouvé, veuillez vérifier et téléverser un fichier valide.',
    errorAddToCartFailed: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, erreur de panier.',
    errorProductNotFound: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, produit introuvable.',
    errorPriceNotAvailable: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, prix introuvable.',
    errorMinOrderQty: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, la quantité commandée doit être supérieure à {{ minOrderQuantity }}.',
    errorDeliveryMultiplier: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, la quantité commandée doit être un multiple de l\'unité de livraison {{ develiveryUnit }}.',
    errorProductDiscontinued: 'Article de ligne {{ lineNo }}, le matériel a été remplacé par {{ code }} pour le numéro de catalogue {{ message }}.',
    errorGeneric: 'Article de ligne {{ lineNo }}, Matériel : {{ code }}, {{ reason }}.',
  },
  message: {
    success: 'Commande importée avec succès.',
    error: 'Une erreur est survenue lors de l\'importation de la commande.',
  },
};

export const quickEntry = {
  label: {
    pageHeader1: 'Saisie rapide',
    cartLimitNote: 'Vous pouvez ajouter jusqu\'à 50 SKU valides ci-dessous et les ajouter au panier',
    resetForm: 'Réinitialiser le formulaire',
    addToCart: 'Ajouter au panier',
    addToQuote: 'Ajouter à la soumission',
    reset: 'Réinitialiser le formulaire',
    minimumOrderQuantity: 'Quantité minimale de commande',
    codeNumber: 'Saisir le n° de code',
  },
  header: {
    product: 'Produit',
    quantity: 'Qté',
    lineNo: 'N° de ligne',
  },
  message: {
    success: 'Ajout au panier effectué avec succès.',
    error: 'Une erreur est survenue lors de l\'ajout au panier.',
    minorderQty: 'Quantité minimale de commande',
    productwarnmsg: 'Ce produit ne peut pas être acheté. Veuillez saisir un autre SKU',
    skuplaceholder: 'Saisir le SKU',
  },
};

export const quickOrder = {
  label: {
    header1: 'Vous pouvez ajouter jusqu\'à 50 SKU valides',
    availability: 'Disponibilité',
    netPrice: 'Prix net',
    minAdvPrice: 'Prix annoncé minimum',
    plant: 'Usine',
    inventory: 'Inventaire',
    estShipDate: 'Date d\'expédition estimée',
    resetForm: 'Réinitialiser le formulaire',
    addToCart: 'Ajouter au panier',
    addToQuote: 'Ajouter à la soumission',
    priceNotAvailable: '"Prix non disponible". Ce produit ne peut pas être ajouté à votre panier pour le moment.',
  },
};

export const knbrOrderDetails = {
  label: {
    srNo: 'Article de la commande',
    orderNumber: 'Numéro de commande',
    orderStatus: 'Statut de la commande',
    orderType: 'Type de commande',
    poNumber: 'Numéro de B.C.',
    referenceNo: 'N° de référence',
    soldTo: 'Vendu à',
    shipTo: 'Expédier à',
    orderCreationDate: 'Date de création de la commande',
    currency: 'Devise',
    orderPlacedBy: 'Commande passée par',
    jobNumber: 'Numéro de travail',
    shippingNotes: 'Notes de livraison',
    reqShipDate: 'Date d\'expédition demandée',
    shippingMethod: 'Mode de livraison',
    totalQty: 'Quantité totale',
    orderTotal: 'Total de la commande',
    downloadDocs: 'Documents',
    qty: 'Qté',
    atpDate: 'Date ATP',
    plant: 'Usine',
    lineItemStatus: 'Statut',
    quoteId: 'ID de soumission',
    openQuantity: 'Quantité ouverte',
    unitNetPrice: 'Prix net unitaire',
    shipments: 'Expéditions',
    orderQty: 'Qté commandée',
    shipQty: 'Qté expédiée',
    shipDate: 'Date d\'expédition',
    originalEstShipDate: 'Date d\'expédition estimée initiale',
    currentEstShipDate: 'Date d\'expédition estimée actuelle',
    lastShipDate: 'Date de dernière expédition',
    totalLinePrice: 'Prix total du poste',
    status: 'Statut',
    deliveryNumber: 'Numéro de livraison',
    carrier: 'Transporteur',
    carrierName: 'Nom du transporteur',
    tracking: 'Suivi',
    trackingId: 'ID de suivi',
    shipFrom: 'Expédié de',
    packingList: 'Liste de colisage',
    freightTerms: 'Conditions de transport',
  },
  actions: {
    reorderAction: 'Recommander',
    returnRMAAction: 'Retourner la commande (RMA)',
    returnZRREAction: 'Retour de commande REP (ZRRE)',
    cancelAction: 'Annuler la commande',
    editAction: 'Modifier la commande',
    saveEditOrder: 'Sauvegarder la commande modifiée',
    cancel: 'Annuler',
    backOrderHistory: 'Retour à l\'historique des commandes',
  },
  reOrderMessage: {
    success: 'La commande a été convertie en brouillon de commande avec succès.',
    error: 'Une erreur est survenue lors de la repassation de la commande.',
  },
  returnOrder: {
    navigationWarning: 'La commande ne peut pas être retournée pour le moment',
  },
  addProducts: {
    product: 'Produit',
    itemDetails: 'Détails de l\'article',
    listPrice: 'Prix de liste',
    qty: 'Qté',
    total: 'Total',
    minorderQty: 'Quantité minimale de commande',
    productwarnmsg: 'Ce produit ne peut pas être acheté. Veuillez saisir un autre SKU',
    skuplaceholder: 'Saisir le SKU',
    lineNo: 'N° de ligne',
    moqWarningMsg: 'La quantité minimale de commande ne correspond pas à la quantité du poste. Veuillez vérifier et mettre à jour',
    priceWarnmsg: 'Ce produit ne peut pas être acheté. Veuillez saisir un autre SKU',
  },
  editOrder: {
    successMsg: 'Votre commande a été modifiée avec succès',
    confirmHeading: 'Votre numéro de commande est',
    processMessage: 'Votre commande est en cours de traitement pour les modifications demandées',
    errorMsg: 'Erreur lors de la modification de la commande',
    backButton: 'Retour à l\'historique des commandes',
    product: 'Produit',
    itemDetails: 'Détails de l\'article',
    listPrice: 'Prix de liste',
    qty: 'Qté',
    total: 'Total',
    cancelItem: 'Annuler le poste',
    qtyMsg: 'Vous pouvez seulement diminuer la quantité',
    addoreditwarnmsg: 'Veuillez ajouter ou modifier au moins un produit',
    cancelReasonMsg: 'Sélectionner le motif d\'annulation',
    cancelSelectWarning: 'Veuillez sélectionner un motif d\'annulation pour les articles annulés',
  },
};

export const orderForms = {
  label: {
    item: 'Article',
    listPrice: 'Prix de liste',
    productDetails: 'Détails du produit',
    qty: 'Qté',
    minQty: 'Quantité minimale de commande',
    total: 'Total',
    qtySelected: 'Quantité sélectionnée : ',
    subTotal: 'Sous-total :',
    createOrderForm: 'CRÉER UN FORMULAIRE DE COMMANDE',
    keywordSearch: 'Recherche par mot-clé',
    onlyProductIds: 'Numéro de catalogue seulement',
    orderForm: 'Formulaire de commande',
    selectProduct: 'Sélectionner un produit',
    productsFound: 'Produits trouvés',
    availability: 'Disponibilité',
    plant: 'Usine',
    inventory: 'Inventaire',
    estShipDate: 'Date d\'expédition estimée',
  },
  nodataMsg: 'Aucun produit trouvé!',
};

export const replacementProduct = {
  header: 'Produit de remplacement',
  obsoleteMsg: 'Le produit a été remplacé par {{code}}.',
  codeNumber: 'Numéro de catalogue :',
};

export const knbrOrderTools = {
  orderImport,
  quickEntry,
  knbrOrderDetails,
  quickOrder,
  orderForms,
  replacementProduct,
};
